import styled from "styled-components"
import { device } from "breakpoints"
import { getGradient } from "helpers/getGradient"

export const DividerLinesContainer = styled.div`
  overflow: visible;
  z-index: -1;
  position: relative;
  /* border: 1px solid red; */
  height: 50px;

  @media ${device.big} {
    margin: 150px 0;
  }

  :after {
    content: "";
    position: absolute;
    height: 1px;
    width: 100vw;
    left: calc(50%);
    bottom: 0;
    display: block;
    right: 0;
    transform-origin: 50%;
    background-image: ${props => getGradient(props.theme.site)};
    transform: skewY(4deg) translateX(-50%);

    @media ${device.tablet} {
      bottom: -18px;
    }

    @media ${device.desktop} {
      bottom: -35px;
      transform: skewY(6deg) translateX(-50%);
    }

    @media ${device.large} {
      transform: skewY(4deg) translateX(-50%);

      bottom: -35px;
    }

    @media ${device.big} {
      bottom: -60px;
    }
  }

  :before {
    content: "";
    border-top: 1px solid;
    border-image-slice: 1;
    border-image-source: ${props => getGradient(props.theme.site)};
    background: white;
    width: 100vw;
    position: absolute;
    bottom: 0;
    left: calc(50%);
    transform-origin: -50%;
    height: 0;
    transform: skewY(-5deg) translateX(-50%) translateY(100%);

    @media ${device.tablet} {
      bottom: -9px;
      transform: skewY(-4deg) translateX(-50%) translateY(100%);
    }
    @media ${device.desktop} {
      bottom: -15px;
    }
    @media ${device.large} {
      bottom: -18px;
    }
    @media ${device.big} {
      bottom: -35px;
    }
  }
`
